import Box from "@mui/material/Box";

import CustomerLogos from "@/components/marketing/CustomerLogos";
import { Lines } from "@/components/marketing/Lines";
import { NOT_WIDE, TINY } from "@/components/marketing/tokens";
import type { Laid } from "@/content/landing/sectionLayout";

type LogoMarquee = Laid<"logoMarquee">;

/**
 * `.container_new.is-logos`: the customer count beside the customers' logos,
 * in the site's 1360 column with 32 over and under and 48 at the sides.
 *
 * `overlay` is how `/enterprise-form` publishes it: set absolutely at the foot
 * of the section above and drawn over that section's bottom edge (32 higher
 * below the wide step), with the page's `.sontact-spacer` under it, 7.5rem
 * and 4rem on a phone.
 * Published, the band also swallows the clicks meant for the form it covers,
 * Send included; here it lets them through, which is the one way it differs.
 */
export default function LogoMarqueeBlock({ block }: { block: LogoMarquee }) {
  const band = (
    <Box
      sx={{
        width: 1,
        maxWidth: "1360px",
        mx: "auto",
        px: "48px",
        py: "32px",
      }}
    >
      <CustomerLogos>
        <Lines text={block.title} />
      </CustomerLogos>
    </Box>
  );
  if (!block.overlay) {
    return <Box component="section">{band}</Box>;
  }
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        height: "7.5rem",
        [TINY]: { height: "4rem" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: "100%",
          pointerEvents: "none",
          [NOT_WIDE]: { mb: "32px" },
        }}
      >
        {band}
      </Box>
    </Box>
  );
}
